import settings from '/@/core/settings';
import { fetchHelper } from '/@/store/session/actions';
import { createAction } from '/@/store/utils';
import { shouldFetchWeather } from './selectors';

export const setField = createAction('WEATHER:SET_FIELD');

export const loadWeather = createAction('WEATHER:LOAD_WEATHER', async ({ getState, payload, dispatch }) => {
    await dispatch(fetchWeather(payload));
    //this prevents from abussive api calls
    if (shouldFetchWeather(payload.id, getState())) {
        await dispatch(fetchWeather(payload));
    }
});

export const fetchWeather = createAction('WEATHER:FETCH_WEATHER', async ({ payload }) => {
    const url = settings.urls.weather.getWeather + `?lat=${payload.lat}&lng=${payload.lng}&system=${payload.system}`;
    let { data } = await fetchHelper(url, {
        method: 'get',
    });
    data = data.data;
    data.field = payload.id;
    return [data];
});
